import { setLocalStorage } from '../../utils/store/localstorage'

const selectedFilterStorageKey = 'selectedFilterStorage'

export default function setTeamAgeIdToFilters(userContext, filterContext) {
  const teamAgeId = userContext?.userSession?.team?.teamAgeId ? userContext?.userSession?.team?.teamAgeId : false
  const teamAgeString = teamAgeId ? teamAgeId.toString() : false
  if (!teamAgeString) return false
  const clearedFilters = {
    exercises: { ageCategories: teamAgeString },
    trainings: { ageCategories: teamAgeString },
    programs: { ageCategories: teamAgeString }
  }
  filterContext.setSelectedFilters(clearedFilters)
  setLocalStorage(selectedFilterStorageKey, clearedFilters)
}
